import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PhoneHangUp = function PhoneHangUp(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.4754 12.8631a19 19 0 0 1-2.3042-5.1018c-.1602-.5644-.2403-.8467-.2415-1.2596-.0014-.4582.16-1.0787.3844-1.4782.2023-.36.467-.6249.9967-1.1545l.1576-.1576c.5315-.5315.7972-.7972 1.0826-.9415a2 2 0 0 1 1.8054 0c.2853.1443.551.41 1.0825.9415l.1949.1949c.3496.3495.5244.5244.6387.7001a2 2 0 0 1 0 2.1804c-.1143.1758-.2891.3506-.6387.7002-.1143.1143-.1715.1715-.2193.2383-.17.2374-.2287.5817-.147.862.023.0789.053.1412.1128.266q.1813.3775.3853.7464m2.4161 3.2182.0449.0452c1.2016 1.2015 2.5603 2.1503 4.0099 2.8463.1247.0599.187.0898.2659.1128.2804.0818.6246.0231.862-.147.0669-.0478.124-.105.2383-.2193.3496-.3496.5244-.5244.7002-.6387a2 2 0 0 1 2.1804 0c.1758.1143.3506.2891.7002.6387l.1948.1949c.5315.5314.7972.7972.9415 1.0825a2 2 0 0 1 0 1.8054c-.1443.2854-.41.5511-.9415 1.0826l-.1576.1576c-.5296.5296-.7944.7944-1.1545.9967-.3995.2244-1.02.3858-1.4782.3844-.4129-.0012-.6952-.0813-1.2596-.2415-3.0334-.861-5.8958-2.4855-8.2837-4.8735L7.9997 16m13-13-18 18"
    })
  }));
};
export default PhoneHangUp;